import transformList from './list';
import transformOut from './out';

export default {
    list: transformList,
    out: transformOut
};
